'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var textHelper = require('../../helper/util').Text;


/*
 * 链接组
 */

var LinkBar = React.createClass({

  getInitialState : function(){
    return {
      selectedIndex : this.props.selectedIndex
    }
  },

  _getArray: function () {
    return textHelper.delimitToWords(styleHelper.getText(this.props));
  },

  render: function () {
    this.textArray = this._getArray();
    var style = styleHelper.StyleUtil(this.props).size().text().lineHeight().default({
      position: 'absolute',
      float: 'left'
    }).style;
    return (<div style={style}>
      {
        this.textArray.map(function (text, index) {
          return (
            <div key={index}
                 ref={index}
                 className="LinkBar-Item"
                 style={this.getItemTextStyle(index)}
                 onClick={this.onItemClick.bind(this, null, index)}>
              <label>{text}</label>
            </div>
          )
        }, this)
      }
      {
        this.textArray.map(function (text, index) {
          if (index < this.textArray.length - 1) {
            return (
              <div key={index} ref={'separator' + index} style={this.getSeparatorStyle()}></div>
            )
          }
        }, this)
      }
    </div>);
  },

  getSeparatorStyle: function () {
    var css = {
      width: 2,
      top: 1,
      height: styleHelper.getHeight(this.props) - 2,
      position: 'absolute',
      backgroundColor: styleHelper.getBackgroundColor(this.props)
    };
    return css;
  },

  getItemTextStyle: function (index) {
    var css = {
      height: styleHelper.getHeight(this.props)
    };
    if (index !== this.state.selectedIndex) {
      css.color = styleHelper.getBackgroundColor(this.props);
    }
    return css;
  },

  onItemClick : function(e,index){
    this.setState({selectedIndex : index})
  },

  componentDidMount: function () {
    this.doAdjustItemBounds();
    $(ReactDOM.findDOMNode(this)).off('itemClick');
    $(ReactDOM.findDOMNode(this)).on('itemClick',this.onItemClick)
  },

  componentDidUpdate: function () {
    this.doAdjustItemBounds();
  },

  doAdjustItemBounds: function () {
    var i = 0;
    var l = this.textArray.length;
    var left = 0;
    var textItem;
    var separatorItem;
    var itemW;
    var gap = styleHelper.getInt(this.props,propConst.GAP);
    for (i; i < l; i++) {
      textItem = ReactDOM.findDOMNode(this.refs[i]);
      itemW = textItem.clientWidth;
      $(textItem).css({left: left});
      left += itemW;
      left += gap / 2;
      if (i < l - 1) {
        separatorItem = ReactDOM.findDOMNode(this.refs['separator' + i]);
        $(separatorItem).css({left: left - 1});
        left += gap / 2;
      }
    }
  }
});

module.exports = LinkBar;



// WEBPACK FOOTER //
// ./src/views/Components/LinkBar.jsx